// @todo rewrite mutations outside vuex
// eslint-disable-next-line
export const strict = false;
